const { connect } = require('react-redux');
const { context } = require('app-context');
const { push: Push } = require('connected-react-router');
const ManageGroupsContents = require('components/ManageGroupsContents');
const { filterGroupsVisibleToUser } = require('utils/groups');

const selectors = context.selectors.all;
const actions   = context.actions;

const internals = {};

module.exports = connect(
    (state) => {

        const currentUser = selectors.getCurrentUser(state);
        const currentUserGroups = selectors.getGroups_forMyGroups(state) || [];
        const rolePermissions = selectors.getCurrentUserRolePermissions(state);
        const allGroups = filterGroupsVisibleToUser(
            selectors.getGroups(state),
            currentUserGroups,
            rolePermissions
        );
        const groupSearchResults = filterGroupsVisibleToUser(
            selectors.getGroups_forGroupSearch(state),
            currentUserGroups,
            rolePermissions
        );

        const usersNameMap = {};

        const usersEntities = state.dataFetching?.entities?.users;
        if (usersEntities) {
            Object.values(usersEntities).forEach((user) => {
                if (user && user.id && user.firstName) {
                    usersNameMap[user.id] = `${user.firstName} ${user.lastName || ''}`.trim();
                }
            });
        }

        const currentUserData = currentUser.user();
        if (currentUserData) {
            usersNameMap[currentUserData.id] = `${currentUserData.firstName} ${currentUserData.lastName}`;
        }

        return {
            rolePermissions,
            isMe: true,
            currentCommunityUnreadCounts: selectors.getCurrentCommunityUnreadCounts(state),
            user: currentUserData,
            allGroups,
            groupSearchResults,
            myCurrentGroups: currentUserGroups,
            currentGroups: currentUserGroups,
            debug: selectors.getDebug(state).groupSorting,
            usersNameMap,
            currentUserId: currentUserData?.id
        };
    },
    (dispatch) => ({
        onRequestSearch: (...args) => dispatch(actions.dataFetching.fetchClassSearchResults(...args)),
        fetchGroups: () => dispatch(actions.dataFetching.fetchClasses()),
        onClickAddToGroup: ({ id, name }) => dispatch(actions.classes.join({ id, name })),
        onClickRemoveFromGroup: (group) => dispatch(actions.classes.leave(group)),
        push: (...args) => dispatch(Push(...args))
    })
)(ManageGroupsContents);
